<template>
  <b-container fluid>
    <!-- Фильтры по датам и кнопка загрузки -->
    <b-row v-if="mobile || tablet" class="mb-3">
      <b-col md="12">
        <div class="d-flex align-items-center">
          <a-month-picker
            class="mr-3"
            size="large"
            v-model="dateStart"
            format="MM/YYYY"
            @change="changeDateStart"
            placeholder="Месяц с"
          />
          <a-month-picker
            class="mr-3"
            size="large"
            v-model="dateEnd"
            format="MM/YYYY"
            @change="changeDateEnd"
            placeholder="Месяц по"
          />
          <b-button
            :disabled="!dateStart"
            type="button"
            variant="success"
            class="text-center action-button mr-3"
            @click="loadPackageStatistic()"
          >
            Загрузить
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- Поиск для мобильных устройств -->
    <b-row v-if="mobile || tablet" class="mb-3">
      <b-col md="12">
        <b-input-group class="search">
          <b-form-input v-model="filter" placeholder="Поиск"/>
          <div class="container_search-close" @click="clearField">
            <span class="search-close">&#215;</span>
          </div>
        </b-input-group>
      </b-col>
    </b-row>

    <!-- Фильтры по датам и поиск для десктопов -->
    <b-row v-if="desktop || largeDesktop" class="mb-4">
      <b-col md="8">
        <div class="d-flex align-items-center">
          <a-month-picker
            class="mr-3"
            size="large"
            v-model="dateStart"
            format="MM/YYYY"
            @change="changeDateStart"
            placeholder="Месяц с"
          />
          <a-month-picker
            class="mr-3"
            size="large"
            v-model="dateEnd"
            format="MM/YYYY"
            @change="changeDateEnd"
            placeholder="Месяц по"
          />
          <b-button
            :disabled="!dateStart"
            type="button"
            variant="success"
            class="text-center action-button mr-3"
            @click="loadPackageStatistic()"
          >
            Загрузить отчет
          </b-button>
        </div>
      </b-col>
      <b-col md="4">
        <b-input-group class="search">
          <b-form-input v-model="filter" placeholder="Поиск"/>
          <div class="container_search-close" @click="clearField">
            <span class="search-close">&#215;</span>
          </div>
        </b-input-group>
      </b-col>
    </b-row>

    <!-- Выбор дилеров с чекбоксами -->
    <b-row v-if="selectDealerOptions.length > 0">
      <b-col md="6">
        <b-form-group label="Выберите дилеров:">
          <!-- Кнопка для раскрытия/скрытия списка дилеров -->
          <b-button
            variant="outline-secondary"
            @click="toggleDealersDropdown"
            class="mb-2 dealers-dropdown-toggle"
          >
            {{ dealersDropdownVisible ? 'Скрыть дилеров' : 'Показать дилеров' }}
            <i class="fas" :class="dealersDropdownVisible ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </b-button>

          <!-- Список дилеров с чекбоксами -->
          <b-collapse v-model="dealersDropdownVisible">
            <div class="dealers-checkbox-list">
              <!-- Чекбокс "Выбрать всех" -->
              <b-form-checkbox
                v-model="selectAllDealers"
                @change="toggleAllDealers"
                class="select-all-dealers mb-2"
              >
                <b>Выбрать всех</b>
              </b-form-checkbox>

              <!-- Список дилеров -->
              <b-form-checkbox-group
                v-model="selectedDealers"
                stacked
                class="dealers-checkbox-group"
              >
                <b-form-checkbox
                  v-for="dealer in selectDealerOptions"
                  :key="dealer.value"
                  :value="dealer.value"
                  class="dealer-checkbox"
                >
                  {{ dealer.text }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </div>
          </b-collapse>
        </b-form-group>

        <!-- div v-if="selectedDealers.length > 0" class="selected-dealers mb-2">
          <small>Выбрано: {{ selectedDealers.length }} дилер(ов)</small>
          <b-badge
            v-if="selectedDealers.length > 0"
            variant="success"
            class="ml-2"
          >
            {{ selectedDealers.length }}
          </b-badge>
        </div -->
      </b-col>

      <b-col md="6" class="d-flex align-items-start justify-content-end">
        <b-dropdown right variant="success">
          <template v-slot:button-content>
            Выгрузить в Excel
          </template>
          <b-dropdown-item @click="downloadDealerExcel(null)">
            <p class="mb-0 download-report">Отфильтрованные записи <i class="fas fa-file-download ml-1"></i></p>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item
            v-for="dealer in selectDealerOptions"
            @click="downloadDealerExcel(dealer.value)"
            :key="dealer.value"
          >
            <p class="mb-0 download-report">{{ dealer.text }} <i class="fas fa-file-download ml-1"></i></p>
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>

    <!-- Информация о количестве записей -->
    <div v-if="allDealerClients && allDealerClients.length" class="filtered-items-number">
      Отфильтровано записей {{ filteredClients.length }} из {{ allDealerClients.length }}
    </div>

    <!-- Основная таблица и калькулятор -->
    <b-row>
      <b-col md="9" sm="9" class="mb-2">
        <b-table
          :striped="striped"
          :stacked="stacked"
          :fixed="fixed"
          hover
          show-empty
          id="data_table"
          :fields="fields"
          :items="parsedPackageStatistic"
          :busy="isBusy"
          :no-provider-paging="true"
          :no-provider-sorting="true"
          :no-provider-filtering="true"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          class="data_table_report mt-3 blue"
          empty-text="Нет данных в таблице"
          empty-filtered-text="Нет данных по вашему запросу"
        >
          <!-- Загрузчик -->
          <div slot="table-busy" class="text-center text-secondary my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Загрузка...</strong>
          </div>

          <!-- Клиент -->
          <template v-slot:head(client)="data">
            {{ data.label }}
          </template>

          <!-- ИНН -->
          <template v-slot:head(inn)="data">
            {{ data.label }}
          </template>
          <template v-slot:cell(inn)="row">
            <div v-if="mobile || tablet || desktop">{{ row.item.inn }} / {{ row.item.kpp }}</div>
            <div v-if="largeDesktop">{{ row.item.inn }}</div>
          </template>

          <!-- КПП -->
          <template v-slot:head(kpp)="data">
            {{ data.label }}
          </template>

          <!-- Месяц -->
          <template v-slot:head(month)="data">
            {{ data.label }}
          </template>
          <template v-slot:cell(month)="row">
            <div
              v-for="(item, key, index) in row.item.detail"
              class="text-center"
              :key="key"
              :style="{
                borderBottom: index !== Object.keys(row.item.detail).length-1 ? '1px solid #dee2e6' : '',
                paddingBottom: index !== Object.keys(row.item.detail).length-1 ? '5px' : '',
                paddingTop: index !== 0 ? '5px' : '',
                marginRight: '-5px',
                marginLeft: '-5px'
              }"
            >
              <div
                v-for="(obj, ind) in row.item.detail[key]"
                :key="ind"
                :style="{
                  borderBottom: ind !== row.item.detail[key].length-1 ? '1px solid #dee2e6' : '',
                  paddingBottom: ind !== row.item.detail[key].length-1 ? '5px' : '',
                  paddingTop: ind !== 0 ? '5px' : '',
                  marginRight: '-5px',
                  marginLeft: '-5px',
                  paddingLeft: '5px'
                }"
              >
                <span v-if="ind === 0">{{ key }}</span>
                <span v-else>{{ key }}</span>
              </div>
            </div>
          </template>

          <!-- Количество -->
          <template v-slot:head(quantity)="data">
            {{ data.label }}
          </template>
          <template v-slot:cell(quantity)="row">
            <div
              v-for="(item, key, index) in row.item.detail"
              class="text-center"
              :key="key"
              :style="{
                borderBottom: index !== Object.keys(row.item.detail).length-1 ? '1px solid #dee2e6' : '',
                paddingBottom: index !== Object.keys(row.item.detail).length-1 ? '5px' : '',
                paddingTop: index !== 0 ? '5px' : '',
                marginRight: '-5px',
                marginLeft: '-5px'
              }"
            >
              <div
                v-for="(obj, ind) in row.item.detail[key]"
                :key="ind"
                :style="{
                  borderBottom: ind !== row.item.detail[key].length-1 ? '1px solid #dee2e6' : '',
                  paddingBottom: ind !== row.item.detail[key].length-1 ? '5px' : '',
                  paddingTop: ind !== 0 ? '5px' : '',
                  marginRight: '-5px',
                  marginLeft: '-5px',
                  paddingLeft: '5px'
                }"
              >
                {{ obj.count }}
              </div>
            </div>
          </template>

          <!-- Расшифровка -->
          <template v-slot:head(detail)="data">
            {{ data.label }}
          </template>
          <template v-slot:cell(detail)="row">
            <div v-if="mobile || tablet || desktop">
              <div
                v-for="(item, key, index) in row.item.detail"
                :key="key"
                :style="{
                  borderBottom: index !== Object.keys(row.item.detail).length-1 ? '1px solid #dee2e6' : '',
                  paddingBottom: index !== Object.keys(row.item.detail).length-1 ? '5px' : '',
                  paddingTop: index !== 0 ? '5px' : '',
                  marginRight: '-5px',
                  marginLeft: '-5px',
                  paddingLeft: '5px'
                }"
              >
                <div
                  v-for="(obj, ind) in row.item.detail[key]"
                  :key="ind"
                  :style="{
                    borderBottom: ind !== row.item.detail[key].length-1 ? '1px solid #dee2e6' : '',
                    paddingBottom: ind !== row.item.detail[key].length-1 ? '5px' : '',
                    paddingTop: ind !== 0 ? '5px' : '',
                    marginRight: '-5px',
                    marginLeft: '-5px',
                    paddingLeft: '5px'
                  }"
                >
                  <div class="details-wrapper" v-if="isSelected(obj.caption)">
                    <b>{{ obj.caption }}</b> <span class="details-wrapper-count">{{ obj.count }}</span>
                  </div>
                  <div class="details-wrapper" v-else>
                    {{ obj.caption }} <span class="details-wrapper-count">{{ obj.count }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="largeDesktop">
              <div
                v-for="(item, key, index) in row.item.detail"
                :key="key"
                :style="{
                  borderBottom: index !== Object.keys(row.item.detail).length-1 ? '1px solid #dee2e6' : '',
                  paddingBottom: index !== Object.keys(row.item.detail).length-1 ? '5px' : '',
                  paddingTop: index !== 0 ? '5px' : '',
                  marginRight: '-5px',
                  marginLeft: '-5px',
                  paddingLeft: '5px'
                }"
              >
                <div
                  v-for="(obj, ind) in row.item.detail[key]"
                  :key="ind"
                  :style="{
                    borderBottom: ind !== row.item.detail[key].length-1 ? '1px solid #dee2e6' : '',
                    paddingBottom: ind !== row.item.detail[key].length-1 ? '5px' : '',
                    paddingTop: ind !== 0 ? '5px' : '',
                    marginRight: '-5px',
                    marginLeft: '-5px',
                    paddingLeft: '5px'
                  }"
                >
                  <b v-if="isSelected(obj.caption)">{{ obj.caption }}</b>
                  <span v-else>{{ obj.caption }}</span>
                </div>
              </div>
            </div>
          </template>

          <!-- Детализация -->
          <template v-slot:head(details)="data">
            {{ data.label }}
          </template>
          <template v-slot:cell(details)="row">
            <div class="text-center">
              <b-button
                v-if="desktop || largeDesktop"
                :disabled="!dateStart"
                @click="getDetails({ 'date': dateForReport, 'org_id': row.item.org_id, 'name': row.item.client })"
              >
                <i class="fas fa-download"></i>
              </b-button>
              <div class="download-details" v-if="tablet || mobile">
                <i class="fas fa-download"></i>
              </div>
            </div>
          </template>
        </b-table>

        <!-- Пагинация -->
        <div class="main-footer">
          <b-form inline>
            <label v-if="desktop || largeDesktop" class="mr-3">Показать</label>
            <b-form-select :options="pageOptions" v-model="perPage" @change="saveOptionSelected"/>
          </b-form>
          <b-pagination
            align="center"
            prev-text="&lt;"
            first-text="&lt;&lt;"
            next-text="&gt;"
            last-text="&gt;&gt;"
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-6"
          >
          </b-pagination>
        </div>
      </b-col>

      <!-- Калькулятор (правая часть) -->
      <b-col md="3" sm="3" class="mb-2 pt-7">
        <b-form-checkbox
          v-if="packageStatistic && packageStatistic.length > 0"
          class="total"
          id="checkbox-1"
          v-model="status"
          name="checkbox-1"
          value="accepted"
          @change="toggleSelection"
          unchecked-value="not_accepted"
        >
          <b>Выделить все</b>
        </b-form-checkbox>
        <b-form-group :key="checkboxFormKey" v-if="packageStatistic && packageStatistic.length > 0">
          <b-form-checkbox
            class="select-total"
            v-for="option in options"
            v-model="selectVal.caption"
            :key="option.key"
            :value="option.value"
            @change="changeOptionCounter"
            name="flavour-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div class="option-text">{{ option.text }}</div>
              <b-badge class="option-count" v-if="option.counter > 0" variant="success">{{ option.counter }}</b-badge>
            </div>
          </b-form-checkbox>
        </b-form-group>
        <hr v-if="packageStatistic && packageStatistic.length > 0">
        <div class="total-wrapper d-flex justify-content-between align-items-center">
          <div>Итого тарифицируемых пакетов:</div>
          <b-badge variant="primary" style="font-size: larger;">{{ totalSelected }}</b-badge>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'PackageStatistic',
  components: {},
  data () {
    return {
      fields: [],
      currentPage: 1,
      totalRows: null,
      perPage: 10,
      pageOptions: [10, 20, 50],
      sortBy: null,
      sortDesc: true,
      sortDirection: 'desc',
      pageOptionSelected: 10,
      filter: null,
      dateStart: null,
      dateEnd: null,
      dateForReport: {
        dateStart: null,
        dateEnd: null,
        dateString: null
      },
      options: [],
      selectVal: {
        caption: []
      },
      status: 'accepted',
      striped: false,
      stacked: false,
      fixed: false,
      responsive: false,
      totalSelected: null,
      selectDealerOptions: [],
      selectedDealers: [], // Массив для выбранных дилеров
      selectAllDealers: false, // Флаг для выбора всех дилеров
      dealersDropdownVisible: true, // Видимость списка дилеров
      packageStatistic: null,
      totals: [],
      total: 0,
      filteredClients: [],
      checkboxFormKey: Math.random(),
      allDealerClients: []
    }
  },
  watch: {
    mobile (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    },
    tablet (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    },
    desktop (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    },
    largeDesktop (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    },
    allDealersPackageStatistic (val) {
      this.selectDealerOptions = []
      this.allDealerClients = []

      for (let i = 0; i < val.length; i++) {
        this.selectDealerOptions.push({ value: val[i].dealer_id, text: val[i].dealer_name })
        if (val[i].data_clients.length > 0) {
          this.allDealerClients.push(...val[i].data_clients)
        }
      }

      // Автоматически выбираем всех дилеров при загрузке
      if (this.selectDealerOptions.length > 0) {
        this.selectedDealers = this.selectDealerOptions.map(option => option.value)
        this.selectAllDealers = true
        this.selectDealers()
      }
    },
    // Отслеживаем изменения выбранных дилеров
    selectedDealers: {
      handler (newVal) {
        // Обновляем флаг "Выбрать всех"
        this.selectAllDealers = newVal.length === this.selectDealerOptions.length

        // Вызываем фильтрацию с задержкой для предотвращения множественных вызовов
        clearTimeout(this.dealersTimeout)
        this.dealersTimeout = setTimeout(() => {
          this.selectDealers()
        }, 300)
      },
      deep: true
    }
  },
  beforeMount () {},
  mounted () {
    this.setTableFields()
  },
  methods: {
    ...mapActions('packageStatistic', [
      'getPackageStatistic',
      'getPackageStatisticExcel',
      'getPackageStatisticFilteredExcel',
      'getDetails'
    ]),
    ...mapMutations('packageStatistic', [
      'setTotal',
      'setTotals',
      'setPackageStatistic'
    ]),

    // Переключение видимости списка дилеров
    toggleDealersDropdown () {
      this.dealersDropdownVisible = !this.dealersDropdownVisible
    },

    // Выбор/снятие всех дилеров
    toggleAllDealers (checked) {
      if (checked) {
        this.selectedDealers = this.selectDealerOptions.map(option => option.value)
      } else {
        this.selectedDealers = []
      }
    },

    setTableFields () {
      if (this.mobile) {
        this.fields = [
          { key: 'client', label: 'Клиент', sortable: false },
          { key: 'inn', label: 'ИНН / КПП', sortable: false },
          { key: 'detail', label: 'Расшифровка / Количество', sortable: false },
          { key: 'details', label: 'Дет.', sortable: false, tdClass: 'align-middle' }
        ]
        this.striped = true
        this.stacked = false
        this.fixed = false
        this.responsive = true
      }
      if (this.tablet) {
        this.fields = [
          { key: 'client', label: 'Клиент', sortable: false },
          { key: 'inn', label: 'ИНН / КПП', sortable: false },
          { key: 'detail', label: 'Расшифровка / Количество', sortable: false },
          { key: 'details', label: 'Детализация', sortable: false, tdClass: 'align-middle' }
        ]
        this.striped = true
        this.stacked = false
        this.fixed = false
        this.responsive = true
      }
      if (this.desktop) {
        this.fields = [
          { key: 'client', label: 'Клиент', sortable: false },
          { key: 'inn', label: 'ИНН / КПП', sortable: false },
          { key: 'month', label: 'Месяц', sortable: false },
          { key: 'detail', label: 'Расшифровка / Количество', sortable: false },
          { key: 'details', label: 'Детализация', sortable: false, tdClass: 'align-middle' }
        ]
        this.striped = true
        this.stacked = false
        this.fixed = false
        this.responsive = true
      }
      if (this.largeDesktop) {
        this.fields = [
          { key: 'client', label: 'Клиент', sortable: false },
          { key: 'inn', label: 'ИНН', sortable: false },
          { key: 'kpp', label: 'КПП', sortable: false },
          { key: 'month', label: 'Месяц', sortable: false },
          { key: 'quantity', label: 'Количество', sortable: false },
          { key: 'detail', label: 'Расшифровка', sortable: false },
          { key: 'details', label: 'Детализация', sortable: false, tdClass: 'align-middle' }
        ]
        this.striped = true
        this.stacked = false
        this.fixed = false
        this.responsive = true
      }
    },
    setFirstItem () {
      if (this.parsedPackageStatistic.length < 1) {
        return 0
      } else {
        return 1
      }
    },
    saveOptionSelected (event) {
      this.pageOptionSelected = event
    },
    calcItems () {
      if (this.currentPage === 1) {
        if ((this.currentPage) + this.pageOptionSelected < this.parsedPackageStatistic.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.parsedPackageStatistic.length
        }
      } else {
        if (((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected < this.parsedPackageStatistic.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.parsedPackageStatistic.length
        }
      }
    },
    downloadDealerExcel (dealerId) {
      if (!dealerId) {
        if (this.filteredClients.length === 0 && this.packageStatistic.length > 0) {
          this.filteredClients = JSON.parse(JSON.stringify(this.packageStatistic))
        }
        const dealersAll = this.filteredClients.map(i => this.allDealersPackageStatistic.find(d => d.data_clients.length > 0 && d.data_clients.find(c => c.org_id === i.org_id)))
        const dealers = [...new Set(dealersAll.map(item => item.dealer_id))]
        const clients = this.filteredClients.map(i => i.org_id)
        if (clients.length === 0 && dealers.length === 0) {
          alert('Нет данных для загрузки')
          return
        }
        this.getPackageStatisticFilteredExcel({ date: this.dateForReport, org_id: this.getOrgId, dealers, clients })
      } else {
        this.getPackageStatisticFilteredExcel({ date: this.dateForReport, org_id: this.getOrgId, dealers: [dealerId], clients: [] })
      }
    },
    // Обновленный метод для обработки множественного выбора дилеров
    selectDealers () {
      this.packageStatistic = []
      this.totals = []
      this.total = 0

      // Если не выбрано ни одного дилера, показываем пустые данные
      if (this.selectedDealers.length === 0) {
        this.totalRows = 0
        this.options = []
        this.selectVal.caption = []
        this.checkboxFormKey += 1
        this.filteredClients = []
        return
      }

      // Собираем данные по выбранным дилерам
      for (let i = 0; i < this.allDealersPackageStatistic.length; i++) {
        if (this.selectedDealers.includes(this.allDealersPackageStatistic[i].dealer_id)) {
          if (this.allDealersPackageStatistic[i].data_clients.length > 0) {
            this.packageStatistic.push(JSON.parse(JSON.stringify(this.allDealersPackageStatistic[i].data_clients)))
          }
          if (this.allDealersPackageStatistic[i].total > 0) {
            this.total += this.allDealersPackageStatistic[i].total
          }
          for (let k = 0; k < this.allDealersPackageStatistic[i].totals.length; k++) {
            const obj = this.totals.find((el) => el.caption === this.allDealersPackageStatistic[i].totals[k].caption)
            if (obj) {
              obj.count += this.allDealersPackageStatistic[i].totals[k].count
            } else {
              this.totals.push(JSON.parse(JSON.stringify(this.allDealersPackageStatistic[i].totals[k])))
            }
          }
        }
      }

      this.packageStatistic = this.packageStatistic.flat()
      this.totals = this.totals.flat()

      this.totalRows = this.packageStatistic.length
      this.options = []
      this.selectVal.caption = []
      this.checkboxFormKey += 1

      for (let i = 0; i < this.totals.length; i++) {
        this.options.push({
          text: this.totals[i].caption,
          value: this.totals[i].caption,
          counter: 0,
          key: Math.random()
        })
        this.selectVal.caption.push(this.totals[i].caption)
      }

      this.filteredClients = JSON.parse(JSON.stringify(this.packageStatistic))
      this.$nextTick(() => {
        this.toggleSelection('not_accepted')
        this.toggleSelection('accepted')
      })
    },
    loadPackageStatistic () {
      this.options = []
      this.packageStatistic = []
      this.totalSelected = null
      this.selectDealerOptions = []
      this.allDealerClients = []
      this.filteredClients = []
      this.selectedDealers = [] // Сбрасываем выбранных дилеров
      this.selectAllDealers = false // Сбрасываем флаг выбора всех
      this.getPackageStatistic({
        date: this.dateForReport,
        org_id: this.getOrgId
      })
    },
    onFiltered (packageStatistic) {
      this.$nextTick(() => {
        if (packageStatistic.length === 0) {
          this.totalRows = null
        } else {
          this.totalRows = packageStatistic.length
        }
      })
      this.filteredClients = JSON.parse(JSON.stringify(packageStatistic))
      this.currentPage = 1
    },
    clearField () {
      this.filter = ''
    },
    changeOptionCounter () {
      this.$nextTick(() => {
        if (this.selectVal.caption.length < this.totals.length) {
          this.status = 'not_accepted'
        } else if (this.selectVal.caption.length === this.totals.length) {
          this.status = 'accepted'
        }
        this.options.forEach(function (v) { v.counter = 0 })
        if (this.packageStatistic && this.packageStatistic.length > 0) {
          this.packageStatistic.forEach((val) => {
            for (const key in val.detail) {
              for (let i = 0; i < val.detail[key].length; i++) {
                for (let j = 0; j < this.selectVal.caption.length; j++) {
                  if (val.detail[key][i].caption === this.selectVal.caption[j]) {
                    const opt = this.options.filter(option => option.text === this.selectVal.caption[j])
                    opt[0].counter += parseInt(val.detail[key][i].count)
                  }
                }
              }
            }
          })
        }
        this.totalRows = this.parsedPackageStatistic.length
        this.totalSelected = this.options.reduce((sum, current) => {
          return sum + current.counter
        }, 0)
      })
    },
    toggleSelection (toggle) {
      if (toggle === 'not_accepted') {
        this.selectVal.caption = []
        this.changeOptionCounter(null)
      } else if (toggle === 'accepted') {
        this.selectVal.caption = []
        for (let i = 0; i < this.totals.length; i++) {
          this.selectVal.caption.push(this.totals[i].caption)
        }
        this.changeOptionCounter(null)
      }
    },
    isSelected (item) {
      const s = this.selectVal.caption.filter(ind => {
        return item === ind
      })
      return s.length > 0
    },
    changeDateStart (value) {
      this.dateStart = value
      if (value) {
        this.dateForReport.dateStart = +this.dateStart.toDate().getFullYear() * 12 + (+this.dateStart.toDate().getMonth() + 1)
        this.dateForReport.dateString = (this.dateStart.toDate().getMonth() + 1) + '_' + this.dateStart.toDate().getFullYear()
        this.selectedMonth = this.dateStart.toDate().getMonth() + 1
        this.selectedYear = this.dateStart.toDate().getFullYear()
      } else {
        this.dateForReport.dateStart = null
        this.dateForReport.dateString = null
        this.selectedMonth = null
        this.selectedYear = null
      }
    },
    changeDateEnd (value) {
      this.dateEnd = value
      if (value) {
        this.dateForReport.dateEnd = +this.dateEnd.toDate().getFullYear() * 12 + (+this.dateEnd.toDate().getMonth() + 1)
      } else {
        this.dateForReport.dateEnd = null
      }
    }
  },
  computed: {
    ...mapState({
      allDealersPackageStatistic: state => state.packageStatistic.allDealersPackageStatistic,
      isBusy: state => state.packageStatistic.isBusy,
      mobile: state => state.mobile,
      tablet: state => state.tablet,
      desktop: state => state.desktop,
      largeDesktop: state => state.largeDesktop
    }),
    getOrgId () {
      return JSON.parse(localStorage.getItem('citadelUserInfo')).company.org_id
    },
    parsedPackageStatistic () {
      if (this.packageStatistic && this.packageStatistic.length > 0 && this.selectVal.caption.length > 0) {
        return JSON.parse(JSON.stringify(this.packageStatistic)).filter(item => {
          for (const key in item.detail) {
            for (let i = 0; i < item.detail[key].length; i++) {
              for (let j = 0; j < this.selectVal.caption.length; j++) {
                let keep = true
                keep = keep && (item.detail[key][i].caption === this.selectVal.caption[j])
                if (keep) {
                  return keep
                }
              }
            }
          }
        })
      } else if (this.packageStatistic && this.packageStatistic.length > 0) {
        return this.packageStatistic
      } else {
        return []
      }
    },
    fieldKeys () {
      return ['caption']
    }
  },
  destroyed () {
    this.setTotal()
    this.setTotals()
    this.setPackageStatistic()
  }
}
</script>

<style lang="scss" scoped>
  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .input-group {
    .form-control:not(:last-child), .custom-select:not(:last-child) {
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
      font-size: 14px;
      height: 40px;
    }
  }

  .action-button {
    height: 40px;
    width: 170px;
  }

  .totals {
    font-size: 14px;
    border-bottom: 1px solid #dee2e6;
    padding: 5px;
  }

  .container_search-close {
    position: absolute;
    right: 11px;
    top: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    z-index: 4;
    &:hover {
      border-radius: 50%;
      background-color: #acacac;
      span {
        color: #fff;
      }
    }
    .search-close {
      font-size: 18px;
      color: #acacac;
      cursor: pointer;
      line-height: 18px;
      width: 18px;
      text-align: center;
      margin-bottom: 2px;
    }
  }

  .filtered-items-number {
    font-size: 14px;
  }

  .details-wrapper {
    width: 100%;
    display: inline-block;
    position: relative;
    .details-wrapper-count {
      position: absolute;
      right: 8px;
    }
  }

  .button-end {
    display: flex;
    justify-content: flex-end;
  }

  .download-report {
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      color: #6c6c6c;
    }
  }

  .selected-dealers {
    font-size: 14px;
    color: #6c757d;
    display: flex;
    align-items: center;
    margin-top: 8px;
  }

  // Стили для списка дилеров с чекбоксами
  .dealers-dropdown-toggle {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
  }

  .dealers-checkbox-list {
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    padding: 12px;
    /* max-height: 300px;*/
    overflow-y: auto;
    background-color: white;
  }

  .select-all-dealers {
    padding: 8px 0;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 8px;
    margin-left: 26px !important;
  }

  .dealers-checkbox-group {
    max-height: 250px;
    overflow-y: auto;
    padding-left: 26px !important;
  }

  .dealer-checkbox {
    padding: 6px 0;
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      background-color: #f8f9fa;
      border-radius: 4px;
    }
  }

  // Стили для скроллбара в списке дилеров
  .dealers-checkbox-group::-webkit-scrollbar {
    width: 6px;
  }

  .dealers-checkbox-group::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .dealers-checkbox-group::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .dealers-checkbox-group::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  @media screen and (min-width: 320px) and (max-width: 1023px) {
    #data_table {
      font-size: 10px;
    }
    .total {
      font-size: 10px;
    }
    .total-wrapper {
      font-size: 10px;
    }
    .select-total {
      font-size: 10px;
    }
    .main-footer {
      font-size: 10px;
    }
    .custom-select {
      font-size: 10px;
    }
    .option-count {
      position: absolute;
      right: 0;
      top: 3px;
    }
    .option-text {
      position: relative;
      top: 3px;
    }
    .download-details {
      font-size: 14px;
      color: #78909c;
    }
    .selected-dealers {
      font-size: 10px;
    }

    // Адаптивные стили для мобильных устройств
    .dealers-checkbox-list {
      max-height: 200px;
      padding: 8px;
    }

    .dealers-dropdown-toggle {
      padding: 6px 10px;
      font-size: 14px;
    }

    .dealer-checkbox {
      font-size: 12px;
      padding: 4px 0;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1439px) {
    .total {
      font-size: 14px;
    }
    .total-wrapper {
      font-size: 14px;
    }
    .select-total {
      font-size: 14px;
    }
    .option-count {
      position: absolute;
      right: 0;
    }
    .selected-dealers {
      font-size: 14px;
    }

    .dealers-checkbox-list {
      max-height: 250px;
    }
  }

  @media screen and (min-width: 1440px) {
    .option-count {
      position: absolute;
      right: 0;
    }
    .selected-dealers {
      font-size: 14px;
    }

    .dealers-checkbox-list {
      /* max-height: 300px; */
    }
  }

  .badge {
    font-size: 87%;
  }

  // Дополнительные стили для улучшения UX
  .dealers-checkbox-group {
    .custom-control {
      margin-bottom: 2px;
    }

    .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #28a745;
      border-color: #28a745;
    }
  }

  .select-all-dealers {
    .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #007bff;
      border-color: #007bff;
    }
  }

  // Анимация для раскрывающегося списка
  .collapsing {
    transition: height 0.3s ease;
  }

  // Стили для состояния загрузки
  .dealers-loading {
    opacity: 0.7;
    pointer-events: none;
  }

  // Стили для пустого списка дилеров
  .dealers-empty {
    text-align: center;
    color: #6c757d;
    padding: 20px;
    font-style: italic;
  }

  // Стили для выделения при наведении
  .dealer-checkbox {
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #e9ecef;
    }
  }

  // Стили для компактного отображения на маленьких экранах
  @media screen and (max-width: 768px) {
    .dealers-checkbox-list {
      max-height: 180px;
    }

    .selected-dealers {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }

  // Стили для темной темы (если используется)
  [data-theme="dark"] {
    .dealers-checkbox-list {
      background-color: #2d3748;
      border-color: #4a5568;
    }

    .dealer-checkbox:hover {
      background-color: #4a5568;
    }

    .select-all-dealers {
      border-bottom-color: #4a5568;
    }
  }
</style>
